import { render, staticRenderFns } from "./w-btn-icon.vue?vue&type=template&id=7b6a864e&lang=pug&"
import script from "./w-btn-icon.vue?vue&type=script&lang=js&"
export * from "./w-btn-icon.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6a864e')) {
      api.createRecord('7b6a864e', component.options)
    } else {
      api.reload('7b6a864e', component.options)
    }
    module.hot.accept("./w-btn-icon.vue?vue&type=template&id=7b6a864e&lang=pug&", function () {
      api.rerender('7b6a864e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-icon.vue"
export default component.exports